<template>
  <section role="main" class="content-body">
    <header class="page-header">
      <h2>聘用資料檢視</h2>
      <div class="right-wrapper">
        <ol class="breadcrumbs">
          <li>
            <a href="/">
              <i class="fa fa-home"></i>
            </a>
          </li>
          <li><span>助學金管理系統</span></li>
          <li><span>工讀生管理</span></li>
          <li><span>工讀生清單</span></li>
          <li><span>聘用資料檢視</span></li>
        </ol>
      </div>
    </header>
    <!-- start: page -->
    <div id="tabs-0" class="row">
      <div id="tabs-03" class="row">
        <div class="col-md-12">
          <section class="panel">
            <div class="panel-body">
              <div class="form-group">
                <label class="col-md-2 control-label">學　　號：</label>
                <div class="col-md-4">{{item.stuId}}</div>
                <label class="col-md-2 control-label">姓　　名：</label>
                <div class="col-md-4">{{item.name}}</div>
              </div>
              <div class="form-group">
                <label class="col-md-2 control-label">性　　別：</label>
                <div class="col-md-4">{{item.sex}}</div>
                <label class="col-md-2 control-label">聯絡電話：</label>
                <div class="col-md-4">{{item.phone}}</div>
              </div>
              <div class="form-group">
                <label class="col-md-2 control-label">身分證字號：</label>
                <div class="col-md-4">{{item.idno}}</div>
                <label class="col-md-2 control-label">出生年月日：</label>
                <div class="col-md-4">{{item.birthday}}</div>
              </div>
              <div class="form-group">
                <label class="col-md-2 control-label">應聘者系所：</label>
                <div class="col-md-4">{{item.deptName}}</div>
                <label class="col-md-2 control-label">年　　級：</label>
                <div class="col-md-4">{{item.grade}}</div>
              </div>
              <div class="form-group">
                <label class="col-md-2 control-label">緊急聯絡人：</label>
                <div class="col-md-4">{{item.parentName}}</div>
                <label class="col-md-2 control-label">關　　係：</label>
                <div class="col-md-4">{{item.kinship}}</div>
              </div>
              <div class="form-group">
                <label class="col-md-2 control-label">聯絡電話：</label>
                <div class="col-md-4">{{item.parentPhone}}</div>
              </div>
              <div class="form-group">
                <label class="col-md-2 control-label">聘僱期間：</label>
                <div class="col-md-10">
                  <font color="#00008B">{{item.workTime}}</font>
                </div>
              </div>
              <div class="form-group">
                <label class="col-md-2 control-label">工作內容：</label>
                <div class="col-md-10">
                  <font color="#00008B">{{item.workContent}}</font>
                </div>
              </div>
              <div class="form-group" v-if="item.workstudyType=='勞雇'">
                <label class="col-md-2 control-label">身分/居留證正面：</label>
                <div class="col-md-4">
                  <a :href="item.identityCardPic1" target="_blank" class="text-muted" v-if="item.identityCardPic1">
                    <img :src="item.identityCardPic1" :alt="item.name + '身分/居留證正面'" style="max-width:300px;" />
                  </a>
                </div>
                <label class="col-md-2 control-label">身分/居留證反面：</label>
                <div class="col-md-4">
                  <a :href="item.identityCardPic2" target="_blank" class="text-muted" v-if="item.identityCardPic2">
                    <img :src="item.identityCardPic2" :alt="item.name + '身分/居留證反面'" style="max-width:300px;" />
                  </a>
                </div>
              </div>
              <div class="form-group" v-if="item.workstudyType=='勞雇'">
                <label class="col-md-2 control-label">工作證正面 ：</label>
                <div class="col-md-4">
                  <a :href="item.workPermitPic1" target="_blank" class="text-muted" v-if="item.workPermitPic1">
                    <img :src="item.workPermitPic1" :alt="item.name + '工作證正面'" style="max-width:300px;" />
                  </a>
                </div>
                <label class="col-md-2 control-label">工作證反面 ：</label>
                <div class="col-md-4">
                  <a :href="item.workPermitPic2" target="_blank" class="text-muted" v-if="item.workPermitPic2">
                    <img :src="item.workPermitPic2" :alt="item.name + '工作證反面'" style="max-width:300px;" />
                  </a>
                </div>
              </div>
              <div class="form-group" v-if="item.workstudyType=='勞雇'">
                <label class="col-md-2 control-label">存簿銀行代碼：</label>
                <div class="col-md-4">{{item.bankNo}}</div>
                <label class="col-md-2 control-label">存簿銀行帳號：</label>
                <div class="col-md-4">{{item.bankAccount}}</div>
              </div>
              <!-- <div class="form-group" v-if="item.workstudyType=='勞雇'">
                <label class="col-md-2 control-label">存簿封面：</label>
                <div class="col-md-4">
                  <a :href="item.bankBookPic" target="_blank" class="text-muted" v-if="item.bankBookPic">
                    <img :src="item.bankBookPic" alt="存簿封面" style="max-width:300px;" />
                  </a>
                </div>
                <label class="col-md-2 control-label">存簿帳號：</label>
                <div class="col-md-4">
                  <span>{{item.bankBookId}}</span><br />
                </div>
              </div> -->

              <div class="form-group">
                <label class="col-md-2 control-label" v-show="item.workstudyType=='勞雇'">
                  <font color="#880000">上傳契約書備存：</font>
                </label>
                <div class="col-md-4" v-show="item.workstudyType=='勞雇'">
                  <div v-if="item.uploadContract">
                    <a :href="item.uploadContract" target="_blank">契約書下載</a>
                  </div>
                  <input type="file" ref="contractFile"> (限pdf檔)
                </div>
                <label class="col-md-2 control-label">
                  <font color="#880000">帳號狀態：</font>
                </label>
                <div class="col-md-4">
                  <input type="radio" :value="true" v-model="accountStatus"> 啟用　　<input type="radio" :value="false" v-model="accountStatus"> 停用
                </div>
              </div>
              <div class="form-group">
                <label class="col-md-12 control-label">
                  隱私權及個人資料保護政策宣告：{{ (customFormatter(item.crDate, "YYYY")-1911) + customFormatter(item.crDate, "年MM月DD日") }} 第{{ !!item.privacyTreatyVersion ? item.privacyTreatyVersion : "1.0" }}版
                </label>
              </div>
              <table width="100%">
                <tr>
                  <td align="center">
                    <a href="#" class="btn-upload btn" style="background-color:#337AB7; border-color:#2E6DA4; color:#FFF;" @click.prevent="formSubmit">儲存</a>
                    <router-link to="/workstudy" class="btn-upload btn" style="background-color:#337AB7; border-color:#2E6DA4; color:#FFF;">返回</router-link>
                  </td>
                </tr>
              </table>
            </div>
          </section>
        </div>
      </div>
    </div>
  </section>

</template>

<script>
export default {
  data() {
    return {
      item: {},
      accountStatus: null
    }
  },
  computed:{
    id() {
      return this.$route.params.id;
    }
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      this.$http.get("/api/workstudy/student-info/" + this.id).then(a => {
        this.item = a.body;
        this.item.identityCardPic1 = "/upload/"+this.item.identityCardPic1;
        this.item.identityCardPic2 = "/upload/"+this.item.identityCardPic2;
        this.accountStatus = a.body.accountStatus;
      });
    },
    formSubmit() {
      let file = this.$refs.contractFile.files[0];
      if (file) {
        if (file.type !== "application/pdf") {
          alert("請上傳PDF檔");
          return false;
        }
        let formData = new FormData();
        formData.append("file", file);
        formData.append("accountStatus", this.accountStatus);
        this.$http
          .post("/api/workstudy/upload-workstudy-info/" + this.id, formData, {
            headers: { "Content-Type": "multipart/form-data" }
          })
          .then(a => {
            if (a.body.status) {
              alert("上傳成功");
              this.$router.push("/workstudy");
            } else {
              alert("上傳失敗:" + a.body.msg);
            }
          });
      } else {
        this.$http
          .post("/api/workstudy/update-workstudy-info/" + this.id, {accountStatus: this.accountStatus})
          .then(a => {
            if (a.body.status) {
              alert("儲存成功");
              this.$router.push("/workstudy");
            } else {
              alert(a.body.msg);
              console.log(a.body.exstr);
            }
          });
      }
    }
  }
};
</script>

<style>
</style>
